import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode'

const getUserFromStorage = () => {
    try {
        const userJson = localStorage.getItem('userData');
        const token = localStorage.getItem('token');
        
        if (!userJson || !token) {
            return null;
        }

        // Parse user data
        const user = JSON.parse(userJson);
        
        // ✅ Validate user has required fields
        if (!user || !user.email || !user.role) {
            localStorage.removeItem('userData');
            localStorage.removeItem('token');
            return null;
        }
        
        // ✅ Validate token
        const decodedToken = jwtDecode(token);
        const tokenExpiry = new Date(decodedToken.exp * 1000);
        const today = new Date();
        
        if (today >= tokenExpiry) {
            localStorage.removeItem('userData');
            localStorage.removeItem('token');
            return null;
        }
        
        return user;
    } catch (error) {
        // ✅ Any error = clear everything
        localStorage.removeItem('userData');
        localStorage.removeItem('token');
        return null;
    }
};

const initialState = {
    authUser: getUserFromStorage(),

    req_loading: false,
    req_error: null,
    req_response: null,

    //temp field, not needed once auth is properly implemented.
    isAuthed: false,

    xeroAuthCode: null
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers:{
        login(state) {
            state.req_loading = true;
        },//not needed
        onLoginStart(state) {
            state.req_loading = true;
        },
        logout(state) {
            state.authUser = null;
        },
        onLoginFailed(state, action){
            state.req_error = action.payload
            state.req_loading = false;
        },
        onLoginSuccess(state, action){
            state.req_loading = false;
            state.req_error = null;

            state.authUser = action.payload
        },
        Update(state, action){
            state.authUser = action.payload
        },
        SetAuthCode(state, action){
            state.xeroAuthCode = action.payload
        }
    }
})

export default authSlice.reducer;
export const authActions = authSlice.actions;